import React from "react";

import { createIcon } from "@chakra-ui/icons";

export const LightningIcon = createIcon({
  displayName: "LightningIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M15 1H8L5 12H11L9 20L19 8H13L15 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

// using `path`
export const BadgeIcon = createIcon({
  displayName: "BadgeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.742 4.738L8.6 1.5 12 3.025v.004-.004L15.4 1.5l1.858 3.238 3.641.773-.39 3.715L23 12l-2.49 2.774.39 3.715-3.641.773L15.4 22.5 12 20.975v-.004.004L8.6 22.5l-1.858-3.238-3.641-.773.39-3.715L1 12l2.49-2.774L3.1 5.51l3.642-.773z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.649 8.72l.963.863L12 14.767l-.91 1.023-3.837-3.85.913-.916 2.87 2.881.964-1.083v.001L15.65 8.72z"
        clipRule="evenodd"
      />
    </g>
  ),
});

export const QuestionIcon = createIcon({
  displayName: "QuestionIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
        stroke="#A1A5AC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"
        stroke="#A1A5AC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const BookIcon = createIcon({
  displayName: "BookIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2V3zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7V3z"
        stroke="#A1A5AC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MailIcon = createIcon({
  displayName: "MailIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6l-10 7L2 6"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const EditIcon = createIcon({
  displayName: "EditIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M14.328 4.672L19.328 9.672"
        stroke="#A1A5AC"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8 21L2 22L3 16L16.414 2.586C16.7891 2.21106 17.2977 2.00043 17.828 2.00043C18.3583 2.00043 18.8669 2.21106 19.242 2.586L21.414 4.758C21.7889 5.13306 21.9996 5.64167 21.9996 6.172C21.9996 6.70233 21.7889 7.21095 21.414 7.586L8 21Z"
        stroke="#A1A5AC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const TrashIcon = createIcon({
  displayName: "TrashIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M3 6H5H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const RemoveIcon = createIcon({
  displayName: "RemoveIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM8 12h8"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MoreVertical = createIcon({
  displayName: "MoreVertical",
  viewBox: "0 0 20 20",
  path: (
    <g fill={"none"}>
      <path
        d="M10 10.8327C10.4602 10.8327 10.8333 10.4596 10.8333 9.99935C10.8333 9.53911 10.4602 9.16602 10 9.16602C9.53976 9.16602 9.16666 9.53911 9.16666 9.99935C9.16666 10.4596 9.53976 10.8327 10 10.8327Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5.00065C10.4602 5.00065 10.8333 4.62756 10.8333 4.16732C10.8333 3.70708 10.4602 3.33398 10 3.33398C9.53976 3.33398 9.16666 3.70708 9.16666 4.16732C9.16666 4.62756 9.53976 5.00065 10 5.00065Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16.6667C10.4602 16.6667 10.8333 16.2936 10.8333 15.8333C10.8333 15.3731 10.4602 15 10 15C9.53976 15 9.16666 15.3731 9.16666 15.8333C9.16666 16.2936 9.53976 16.6667 10 16.6667Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MoveIcon = createIcon({
  displayName: "MoveIcon",
  viewBox: "0 0 20 20",
  path: (
    <g fill={"none"}>
      <path
        d="M4.16667 7.5L1.66667 10L4.16667 12.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 4.16602L10 1.66602L12.5 4.16602"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 15.834L10 18.334L7.5 15.834"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 7.5L18.3333 10L15.8333 12.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66667 10H18.3333"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1.66602V18.3327"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const RemoveFullIcon = createIcon({
  displayName: "RemoveFullIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12h8"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ListIcon = createIcon({
  displayName: "ListIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const DotIcon = createIcon({
  displayName: "CircleIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <circle cx="12" cy="12" r="12" fill="currentColor" />
    </g>
  ),
});

export const InfoIcon = createIcon({
  displayName: "InfoIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 16v-4M12 8h.01"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const UsersIcon = createIcon({
  displayName: "UsersIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const UserIcon = createIcon({
  displayName: "UserIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
        stroke="#A1A5AC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        stroke="#A1A5AC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const PinIcon = createIcon({
  displayName: "PinIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1118 0z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13a3 3 0 100-6 3 3 0 000 6z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const FileIcon = createIcon({
  displayName: "FileIcon",
  viewBox: "0 0 24",
  path: (
    <g fill="none">
      <path
        d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 2V9H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MenuIcon = createIcon({
  displayName: "MenuIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M3 12h18M3 6h18M3 18h18"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const CollapseRightIcon = createIcon({
  displayName: "CollapseRightIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        d="M13.435 8.464a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414l-2.829 2.829a1 1 0 1 1-1.414-1.415L14.556 13H3a1 1 0 1 1 0-2h11.556l-1.121-1.121a1 1 0 0 1 0-1.415z"
        clipRule="evenodd"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M21 4.5a1 1 0 0 1 1 1v13a1 1 0 1 1-2 0v-13a1 1 0 0 1 1-1z"
        fill="currentColor"
      />
    </g>
  ),
});

export const CollapseLeftIcon = createIcon({
  displayName: "CollapseLeftIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        d="M10.565 15.536a1 1 0 0 1-1.414 0l-2.829-2.829a1 1 0 0 1 0-1.414l2.829-2.829a1 1 0 0 1 1.414 1.415L9.444 11H21a1 1 0 1 1 0 2H9.444l1.121 1.121a1 1 0 0 1 0 1.415Z"
        clipRule="evenodd"
        fill="currentColor"
      />
      <path
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        d="M3 19.5a1 1 0 0 1-1-1v-13a1 1 0 1 1 2 0v13a1 1 0 0 1-1 1Z"
      />
    </g>
  ),
});

export const FilterIcon = createIcon({
  displayName: "FilterIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M.75 6.759h6.68a3.006 3.006 0 002.903 2.259 3.006 3.006 0 002.903-2.26H23.25a.75.75 0 000-1.5H13.236A3.006 3.006 0 0010.333 3 3.006 3.006 0 007.43 5.259H.75a.75.75 0 000 1.5zM10.333 4.5a1.51 1.51 0 011.509 1.509 1.51 1.51 0 01-1.509 1.509 1.51 1.51 0 01-1.509-1.51A1.51 1.51 0 0110.333 4.5zM23.25 11.259h-1.606A3.006 3.006 0 0018.74 9a3.006 3.006 0 00-2.902 2.259H.75a.75.75 0 000 1.5h15.089a3.006 3.006 0 002.902 2.259 3.006 3.006 0 002.903-2.26h1.606a.75.75 0 000-1.5zm-4.509 2.259a1.51 1.51 0 01-1.509-1.51 1.51 1.51 0 011.51-1.508 1.51 1.51 0 011.508 1.509 1.51 1.51 0 01-1.509 1.509zM23.25 17.259H8.718A3.005 3.005 0 005.816 15a3.006 3.006 0 00-2.902 2.259H.75a.75.75 0 000 1.5h2.164a3.006 3.006 0 002.902 2.259 3.005 3.005 0 002.902-2.26H23.25a.75.75 0 000-1.5zM5.816 19.518a1.51 1.51 0 01-1.508-1.51A1.51 1.51 0 015.816 16.5a1.51 1.51 0 011.508 1.509 1.51 1.51 0 01-1.508 1.509z"
        fill="currentColor"
      />
    </g>
  ),
});

export const FilterIconAlt = createIcon({
  displayName: "FilterIconAlt",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const CalendarIcon = createIcon({
  displayName: "CalendarIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ExternalIcon = createIcon({
  displayName: "ExternalIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ChevronRightIcon = createIcon({
  displayName: "ChevronRightIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M9 18L15 12L9 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ChevronLeftIcon = createIcon({
  displayName: "ChevronLeftIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M15 18L9 12L15 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ChevronDownIcon = createIcon({
  displayName: "ChevronDownIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ChevronUpIcon = createIcon({
  displayName: "ChevronUpIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M18 15L12 9L6 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const CloseIcon = createIcon({
  displayName: "CloseIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export const LockIcon = createIcon({
  displayName: "LockIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ClockIcon = createIcon({
  displayName: "CloseIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6v6l4 2"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const CircleCheckIcon = createIcon({
  displayName: "CircleCheckIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M22 11.08V12a10 10 0 11-5.93-9.14"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 4L12 14.01l-3-3"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const BriefcaseIcon = createIcon({
  displayName: "BriefcaseIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"
      ></path>
    </g>
  ),
});

export const CircleTickIcon = createIcon({
  displayName: "CircleTickIcon",
  viewBox: "0 0 20 20",
  path: (
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="10" cy="10" r="10" fill="currentColor"></circle>
      <path
        stroke="#000611"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6.25 11.0327388L8.34633616 13.75 13.75 7.5"
      ></path>
    </g>
  ),
});

export const CircleIcon = createIcon({
  displayName: "CircleIcon",
  viewBox: "0 0 20 20",
  path: (
    <path
      fill="currentColor"
      d="M9.875.625C4.697.625.5 4.822.5 10s4.197 9.375 9.375 9.375S19.25 15.178 19.25 10 15.053.625 9.875.625"
    ></path>
  ),
});

export const ArrowUpIcon = createIcon({
  displayName: "ArrowUpIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 19V5M5 12l7-7 7 7"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ArrowDownIcon = createIcon({
  displayName: "ArrowDownIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 5v14M19 12l-7 7-7-7"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const HeartCardIcon = createIcon({
  displayName: "HeartCardIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        fill="rgba(0,0,0,0.15)"
        d="M20.84 3.61a5.5 5.5 0 00-7.78 0L12 4.67l-1.06-1.06a5.501 5.501 0 00-7.78 7.78l1.06 1.06L12 20.23l7.78-7.78 1.06-1.06a5.501 5.501 0 000-7.78v0z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const HeartIcon = createIcon({
  displayName: "HeartIcon",
  viewBox: "0 0 24 22",
  path: (
    <path
      fill="none"
      d="M20.84 3.61a5.5 5.5 0 00-7.78 0L12 4.67l-1.06-1.06a5.501 5.501 0 00-7.78 7.78l1.06 1.06L12 20.23l7.78-7.78 1.06-1.06a5.501 5.501 0 000-7.78v0z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export const HeartFullIcon = createIcon({
  displayName: "HeartFullIcon",
  viewBox: "0 0 24 24",
  path: (
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    >
      <g clipPath="url(#clip0_6225_17479)">
        <path
          d="M21.2429 3.761C20.1178 2.63617 18.5919 2.00428 17.0009 2.00428C15.41 2.00428 13.8841 2.63617 12.7589 3.761C12.4759 4.04448 12.2216 4.35533 11.9999 4.689C11.538 3.98733 10.9338 3.39049 10.2266 2.93711C9.51935 2.48374 8.72478 2.18393 7.89433 2.05711C7.06387 1.93028 6.21604 1.97927 5.40571 2.20088C4.59539 2.4225 3.84063 2.81181 3.1903 3.34361C2.53998 3.87542 2.00857 4.53786 1.6305 5.28806C1.25242 6.03826 1.03609 6.85949 0.995526 7.6986C0.954957 8.5377 1.09105 9.37597 1.39499 10.1591C1.69893 10.9423 2.16395 11.6529 2.75994 12.245L11.9999 21.486L21.2409 12.245C22.3655 11.1199 22.9972 9.59424 22.9972 8.0035C22.9972 6.41276 22.3655 4.88712 21.2409 3.762L21.2429 3.761Z"
          fill="#BE2076"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_6225_17479">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
});

export const ScrollDownIcon = createIcon({
  displayName: "ScrollDownIcon",
  viewBox: "0 0 40 40",
  path: (
    <g>
      <circle
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        cx="20"
        cy="20"
        r="18"
        className="st0"
      ></circle>
      <path
        fill="currentColor"
        d="M20 40C9 40 0 31 0 20S9 0 20 0s20 9 20 20-9 20-20 20zm0-36C11.2 4 4 11.2 4 20s7.2 16 16 16 16-7.2 16-16S28.8 4 20 4z"
        className="st1"
      ></path>
      <path
        fill="currentColor"
        d="M26.8 20.4c-.4-.4-1-.4-1.4 0l-4.2 4.1v-11c0-.6-.4-1-1-1s-1 .4-1 1v11l-4.4-4.1c-.4-.4-1-.4-1.4.1-.4.4-.4 1 .1 1.4l6.2 5.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3l5.8-5.7c.3-.5.3-1.1-.1-1.5z"
        className="st1"
      ></path>
    </g>
  ),
});

export const RadioIcon = createIcon({
  displayName: "RadioIcon",
  viewBox: "0 0 16 16",
  path: (
    <g>
      <circle cx={8} cy={8} r={8} fill="#101820" />
      <circle cx={8} cy={8} r={6} fill="#fff" />
    </g>
  ),
});

export const RadioSelectedIcon = createIcon({
  displayName: "RadioSelectedIcon",
  viewBox: "0 0 16 16",
  path: (
    <g>
      <circle cx={8} cy={8} r={5} fill="none" stroke="#fff" strokeWidth={6} />
    </g>
  ),
});

export const SearchIcon = createIcon({
  displayName: "SearchIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35"
    />
  ),
});

export const SearchIcon2 = createIcon({
  displayName: "SearchIcon2",
  viewBox: "0 0 48 48",
  path: (
    <g fill={"none"}>
      <path
        d="M44 44L31.314 31.314"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const Search2Icon = createIcon({
  displayName: "Search2Icon",
  viewBox: "0 0 23 23",
  path: (
    <g fill={"none"}>
      <path
        d="M16.9206 14.9161L16.6755 15.2606L16.9745 15.5596L22.2075 20.7926C22.3951 20.9802 22.5005 21.2347 22.5005 21.5C22.5005 21.7654 22.3951 22.0198 22.2075 22.2075C22.0198 22.3951 21.7654 22.5005 21.5 22.5005C21.2347 22.5005 20.9802 22.3951 20.7926 22.2075L15.5596 16.9745L15.2606 16.6755L14.9161 16.9206C13.1736 18.1605 11.0287 18.7004 8.90684 18.4333C6.78493 18.1661 4.84084 17.1115 3.45996 15.4784C2.07908 13.8453 1.36222 11.7529 1.45147 9.61614C1.54072 7.47935 2.42957 5.45409 3.94183 3.94183C5.45409 2.42957 7.47935 1.54072 9.61614 1.45147C11.7529 1.36222 13.8453 2.07908 15.4784 3.45996C17.1115 4.84084 18.1661 6.78493 18.4333 8.90684C18.7004 11.0287 18.1605 13.1736 16.9206 14.9161ZM9.99944 17.5H10C11.4834 17.5 12.9334 17.0601 14.1668 16.236C15.4002 15.4119 16.3614 14.2406 16.9291 12.8701C17.4968 11.4997 17.6453 9.99169 17.3559 8.53683C17.0665 7.08197 16.3522 5.7456 15.3033 4.69671C14.2544 3.64781 12.918 2.93351 11.4632 2.64412C10.0083 2.35473 8.50033 2.50326 7.12988 3.07091C5.75944 3.63857 4.5881 4.59986 3.76399 5.83323C2.93988 7.0666 2.50001 8.51665 2.50001 10H3.00001L2.50001 10.0006C2.50228 11.9889 3.29312 13.895 4.69905 15.301C6.10497 16.7069 8.01116 17.4977 9.99944 17.5Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </g>
  ),
});

export const BellIcon = createIcon({
  displayName: "BellIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9zM13.73 21a2 2 0 01-3.46 0"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const Bell2Icon = createIcon({
  displayName: "BellI2con",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M19 11V8C19 6.14348 18.2625 4.36301 16.9497 3.05025C15.637 1.7375 13.8565 1 12 1C10.1435 1 8.36301 1.7375 7.05025 3.05025C5.7375 4.36301 5 6.14348 5 8V11C5 14.3 2 15.1 2 17C2 18.7 5.9 20 12 20C18.1 20 22 18.7 22 17C22 15.1 19 14.3 19 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 22C10.989 22 10.039 21.966 9.14502 21.9C9.33561 22.508 9.71532 23.0393 10.2288 23.4164C10.7424 23.7936 11.3629 23.997 12 23.997C12.6372 23.997 13.2577 23.7936 13.7712 23.4164C14.2847 23.0393 14.6644 22.508 14.855 21.9C13.961 21.966 13.011 22 12 22Z"
        fill="currentColor"
      />
    </g>
  ),
});

export const SupportIcon = createIcon({
  displayName: "SupportIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
        fill="currentColor"
      />
      <path
        d="M9.85303 6.56001C11.833 5.68501 14.395 5.78901 15.27 7.20501C16.145 8.62101 15.541 10.268 14.041 11.539C12.541 12.81 12 13.5 12 14.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const HelpIcon = createIcon({
  displayName: "HelpIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09 9C9.3251 8.33167 9.78915 7.7681 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15848 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17H12.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MessagesIcon = createIcon({
  displayName: "MessagesIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M1.61401 3.55798L12 13L22.385 3.55898"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M21 3H3C1.89543 3 1 3.89543 1 5V19C1 20.1046 1.89543 21 3 21H21C22.1046 21 23 20.1046 23 19V5C23 3.89543 22.1046 3 21 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const EnvelopeIcon = createIcon({
  displayName: "EnvelopeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const DownloadIcon = createIcon({
  displayName: "DownloadIcon",
  viewBox: "0 0 22 22",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M21 12c-.6 0-1 .4-1 1v7H2v-7c0-.6-.4-1-1-1s-1 .4-1 1v9h22v-9c0-.6-.4-1-1-1z"
      />
      <path
        fill="currentColor"
        d="M11.4 14.7l6-6c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3.6 3.6V1c0-.6-.4-1-1-1s-1 .4-1 1v9.9L6.8 7.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l6 6z"
      />
    </g>
  ),
});

export const ImportIcon = createIcon({
  displayName: "ImportIcon",
  viewBox: "0 0 20 20",
  path: (
    <g fill="none">
      <path
        d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 6L10 1L5 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ExportIcon = createIcon({
  displayName: "ExportIcon",
  viewBox: "0 0 20 20",
  path: (
    <g fill="none">
      <path
        d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8L10 13L15 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13V1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const EyeIcon = createIcon({
  displayName: "EyeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15a3 3 0 100-6 3 3 0 000 6z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const EyeOffIcon = createIcon({
  displayName: "EyeOffIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M14.12 14.12a3 3 0 11-4.24-4.24m8.06 8.06A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94l11.88 11.88zM9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.498 18.498 0 01-2.16 3.19L9.9 4.24zM1 1l22 22"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const AlertError = createIcon({
  displayName: "AlertError",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM12 8v4M12 16h.01"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const AlertTriangle = createIcon({
  displayName: "AlertTriangle",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M10.2898 3.85999L1.81978 18C1.64514 18.3024 1.55274 18.6453 1.55177 18.9945C1.55079 19.3437 1.64127 19.6871 1.8142 19.9905C1.98714 20.2939 2.2365 20.5467 2.53748 20.7238C2.83847 20.9009 3.18058 20.9962 3.52978 21H20.4698C20.819 20.9962 21.1611 20.9009 21.4621 20.7238C21.7631 20.5467 22.0124 20.2939 22.1854 19.9905C22.3583 19.6871 22.4488 19.3437 22.4478 18.9945C22.4468 18.6453 22.3544 18.3024 22.1798 18L13.7098 3.85999C13.5315 3.5661 13.2805 3.32311 12.981 3.15447C12.6814 2.98584 12.3435 2.89725 11.9998 2.89725C11.656 2.89725 11.3181 2.98584 11.0186 3.15447C10.7191 3.32311 10.468 3.5661 10.2898 3.85999V3.85999Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17H12.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const AlertErrorCurrentColor = createIcon({
  displayName: "AlertError",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM12 8v4M12 16h.01"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const CheckIcon = createIcon({
  displayName: "Check",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M20 6L9 17l-5-5"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const CheckIcon2 = createIcon({
  displayName: "CheckIcon2",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M20 6L9 17l-5-5"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const UploadIcon = createIcon({
  displayName: "UploadIcon",
  viewBox: "0 0 40 40",
  path: (
    <g fill="none">
      <path
        d="M26.667 26.667L20.001 20l-6.667 6.667M20 20v15"
        stroke="#A1A5AC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.984 30.65A8.333 8.333 0 0030 15h-2.1A13.332 13.332 0 008.736 6.565 13.334 13.334 0 005 27.168"
        stroke="#A1A5AC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.667 26.667L20.001 20l-6.667 6.667"
        stroke="#A1A5AC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MenuHomeIcon = createIcon({
  displayName: "MenuHomeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M10 23V17H14V23"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M1 11L12 2L23 11"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M4 8.545V4"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M4 13V23H20V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M13 11H11V13H13V11Z" fill="#6A6E74" />
      <path
        d="M13 11H11V13H13V11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const MenuContactsIcon = createIcon({
  displayName: "MenuContactsIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M11.992 11.737L14.2 13.4C14.4484 13.5863 14.65 13.8279 14.7889 14.1056C14.9277 14.3833 15 14.6895 15 15V16H7V15C7 14.6895 7.07229 14.3833 7.21115 14.1056C7.35 13.8279 7.55161 13.5863 7.8 13.4L10.008 11.737"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M13 9C13 7.89543 12.1046 7 11 7C9.89543 7 9 7.89543 9 9V10C9 11.1046 9.89543 12 11 12C12.1046 12 13 11.1046 13 10V9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M2 1H18C18.5304 1 19.0391 1.21071 19.4142 1.58579C19.7893 1.96086 20 2.46957 20 3V21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23H2V1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M23 5V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const MenuAccountsIcon = createIcon({
  displayName: "MenuAccountsIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M5.99683 11.9992H7.19683"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.99683 7H7.19683"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10.8015 7H18.0015"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10.8015 12.0004H18.0015"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10.8015 16.8004H18.0015"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.99683 16.9996H7.19683"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21.9984 1.9996H1.99841V21.9996H21.9984V1.9996Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const MenuInvestmentsIcon = createIcon({
  displayName: "MenuInvestmentsIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 5V19"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.375 7.21901C13.754 6.32801 8.648 5.66301 8.648 8.73201C8.648 12.406 15.132 11.109 15.132 14.351C15.132 17.593 10.918 17.349 8 16.296"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const MenuOpportunitiesIcon = createIcon({
  displayName: "MenuOpportunitiesIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M5 23H1V13H5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9 16H11"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9 19H11"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9 13H11"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M13 6V2L23 5V23H5V9H15V23"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M19 19V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const MenuOfferingsIcon = createIcon({
  displayName: "MenuOfferingsIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M13.243 22.414L18.414 17.243C18.5998 17.0573 18.7472 16.8368 18.8478 16.5941C18.9483 16.3513 19.0001 16.0912 19.0001 15.8285C19.0001 15.5658 18.9483 15.3057 18.8478 15.0629C18.7472 14.8202 18.5998 14.5997 18.414 14.414L9 5H1V13L10.414 22.414C10.5997 22.5998 10.8202 22.7472 11.0629 22.8478C11.3057 22.9483 11.5658 23.0001 11.8285 23.0001C12.0912 23.0001 12.3514 22.9483 12.5941 22.8478C12.8368 22.7472 13.0573 22.5998 13.243 22.414Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 11L11 1H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6 12C7.10457 12 8 11.1046 8 10C8 8.89543 7.10457 8 6 8C4.89543 8 4 8.89543 4 10C4 11.1046 4.89543 12 6 12Z"
        fill="currentColor"
      />
    </g>
  ),
});

export const MenuReportsIcon = createIcon({
  displayName: "MenuReportsIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M14 3H10V21H14V3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5 14H1V21H5V14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M23 9H19V21H23V9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const MenuProfileIcon = createIcon({
  displayName: "MenuProfileIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M2 8H22"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8 8V22"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const MenuImportIcon = createIcon({
  displayName: "MenuImportIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <g
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        clipPath="url(#a)"
      >
        <path strokeLinecap="square" d="M2 16v6h20v-6" />
        <path d="M12 17V2" />
        <path strokeLinecap="square" d="m18 8-6-6-6 6" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </g>
  ),
});

export const MenuPortalSettingsIcon = createIcon({
  displayName: "MenuPortalSettingsIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M20 12C19.9988 11.4239 19.9358 10.8496 19.812 10.287L22.526 8.232L20.526 4.768L17.383 6.094C16.5319 5.3137 15.5217 4.72723 14.422 4.375L14 1H10L9.578 4.375C8.47834 4.72723 7.46814 5.3137 6.617 6.094L3.474 4.768L1.474 8.232L4.188 10.287C3.93739 11.4153 3.93739 12.5847 4.188 13.713L1.474 15.768L3.474 19.232L6.617 17.906C7.46814 18.6863 8.47834 19.2728 9.578 19.625L10 23H14L14.422 19.625C15.5217 19.2728 16.5319 18.6863 17.383 17.906L20.526 19.232L22.526 15.768L19.812 13.713C19.9358 13.1504 19.9988 12.5761 20 12V12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const AttachmentIcon = createIcon({
  displayName: "AttachmentIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M21.44 11.05L12.25 20.24C11.1242 21.3658 9.59723 21.9983 8.00505 21.9983C6.41286 21.9983 4.88589 21.3658 3.76005 20.24C2.6342 19.1142 2.00171 17.5872 2.00171 15.995C2.00171 14.4028 2.6342 12.8758 3.76005 11.75L12.95 2.56C13.7006 1.80943 14.7186 1.38777 15.78 1.38777C16.8415 1.38777 17.8595 1.80943 18.61 2.56C19.3606 3.31056 19.7823 4.32854 19.7823 5.39C19.7823 6.45145 19.3606 7.46943 18.61 8.22L9.41005 17.41C9.03476 17.7853 8.52577 17.9961 7.99505 17.9961C7.46432 17.9961 6.95533 17.7853 6.58005 17.41C6.20476 17.0347 5.99393 16.5257 5.99393 15.995C5.99393 15.4643 6.20476 14.9553 6.58005 14.58L15.07 6.1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MapPinIcon = createIcon({
  displayName: "MapPinIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ImageIcon = createIcon({
  displayName: "ImageIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 15L16 10L5 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const VideoIcon = createIcon({
  displayName: "VideoIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M23 7L16 12L23 17V7Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H14C15.1046 19 16 18.1046 16 17V7C16 5.89543 15.1046 5 14 5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MailAtIcon = createIcon({
  displayName: "MailAtIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 8V13C16 13.7957 16.3161 14.5587 16.8787 15.1213C17.4413 15.6839 18.2044 16 19 16C19.7957 16 20.5587 15.6839 21.1213 15.1213C21.6839 14.5587 22 13.7957 22 13V12C21.9999 9.74303 21.2362 7.55248 19.8333 5.78454C18.4303 4.01659 16.4706 2.77523 14.2726 2.2623C12.0747 1.74937 9.76794 1.99505 7.72736 2.95937C5.68677 3.9237 4.03241 5.54996 3.03327 7.57373C2.03413 9.5975 1.74898 11.8997 2.22418 14.1061C2.69938 16.3125 3.90699 18.2932 5.65064 19.7263C7.39429 21.1593 9.57144 21.9604 11.8281 21.9992C14.0847 22.038 16.2881 21.3122 18.08 19.94"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

/* Social Icons */

export const SocialLinkedinIcon = createIcon({
  displayName: "SocialLinkedinIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M10.6667 5.33336C11.7276 5.33336 12.745 5.75479 13.4952 6.50493C14.2453 7.25508 14.6667 8.27249 14.6667 9.33336V14H12.0001V9.33336C12.0001 8.97974 11.8596 8.6406 11.6096 8.39055C11.3595 8.1405 11.0204 8.00003 10.6667 8.00003C10.3131 8.00003 9.97399 8.1405 9.72394 8.39055C9.47389 8.6406 9.33341 8.97974 9.33341 9.33336V14H6.66675V9.33336C6.66675 8.27249 7.08818 7.25508 7.83832 6.50493C8.58847 5.75479 9.60588 5.33336 10.6667 5.33336V5.33336Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.99992 6.00002H1.33325V14H3.99992V6.00002Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66659 4C3.40297 4 3.99992 3.40305 3.99992 2.66667C3.99992 1.93029 3.40297 1.33334 2.66659 1.33334C1.93021 1.33334 1.33325 1.93029 1.33325 2.66667C1.33325 3.40305 1.93021 4 2.66659 4Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const SocialFacebookIcon = createIcon({
  displayName: "SocialFacebookIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M12.0001 1.33334H10.0001C9.11603 1.33334 8.26818 1.68453 7.64306 2.30965C7.01794 2.93477 6.66675 3.78261 6.66675 4.66667V6.66667H4.66675V9.33334H6.66675V14.6667H9.33341V9.33334H11.3334L12.0001 6.66667H9.33341V4.66667C9.33341 4.48986 9.40365 4.32029 9.52868 4.19526C9.6537 4.07024 9.82327 4 10.0001 4H12.0001V1.33334Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const SocialInstagramIcon = createIcon({
  displayName: "SocialInstagramIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M11.3333 1.33334H4.66659C2.82564 1.33334 1.33325 2.82572 1.33325 4.66667V11.3333C1.33325 13.1743 2.82564 14.6667 4.66659 14.6667H11.3333C13.1742 14.6667 14.6666 13.1743 14.6666 11.3333V4.66667C14.6666 2.82572 13.1742 1.33334 11.3333 1.33334Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6666 7.58002C10.7488 8.13485 10.6541 8.7015 10.3957 9.19936C10.1374 9.69723 9.72865 10.101 9.22764 10.3531C8.72662 10.6053 8.15885 10.6931 7.60508 10.604C7.0513 10.5149 6.53973 10.2534 6.14311 9.85679C5.7465 9.46018 5.48504 8.9486 5.39593 8.39483C5.30682 7.84105 5.3946 7.27328 5.64677 6.77227C5.89894 6.27125 6.30268 5.86251 6.80054 5.60418C7.29841 5.34585 7.86506 5.25108 8.41989 5.33335C8.98583 5.41727 9.50979 5.68099 9.91435 6.08556C10.3189 6.49012 10.5826 7.01407 10.6666 7.58002Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 4.33336H11.6734"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const SocialYoutubeIcon = createIcon({
  displayName: "SocialYoutubeIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M15.0266 4.28C14.9474 3.9636 14.7862 3.67371 14.5591 3.4396C14.332 3.20549 14.0471 3.03545 13.7333 2.94666C12.5866 2.66666 7.99997 2.66666 7.99997 2.66666C7.99997 2.66666 3.41331 2.66666 2.26664 2.97333C1.95281 3.06212 1.66796 3.23216 1.44087 3.46627C1.21378 3.70038 1.0525 3.99027 0.973308 4.30666C0.763451 5.47037 0.660798 6.65087 0.666641 7.83333C0.65916 9.02469 0.761819 10.2142 0.973308 11.3867C1.06061 11.6932 1.22551 11.9721 1.45207 12.1963C1.67863 12.4205 1.95919 12.5825 2.26664 12.6667C3.41331 12.9733 7.99997 12.9733 7.99997 12.9733C7.99997 12.9733 12.5866 12.9733 13.7333 12.6667C14.0471 12.5779 14.332 12.4078 14.5591 12.1737C14.7862 11.9396 14.9474 11.6497 15.0266 11.3333C15.2349 10.1784 15.3375 9.00689 15.3333 7.83333C15.3408 6.64197 15.2381 5.45246 15.0266 4.28V4.28Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 10.0133L10.3333 7.83332L6.5 5.65332V10.0133Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const SocialTwitterIcon = createIcon({
  displayName: "SocialTwitterIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M15.3333 1.99999C14.6949 2.45031 13.988 2.79473 13.24 3.01999C12.8385 2.55833 12.3048 2.23112 11.7113 2.08261C11.1178 1.9341 10.493 1.97145 9.92135 2.18963C9.34974 2.4078 8.85892 2.79626 8.51528 3.30247C8.17164 3.80868 7.99176 4.40821 7.99996 5.01999V5.68666C6.82838 5.71704 5.66748 5.4572 4.62063 4.93029C3.57379 4.40338 2.6735 3.62575 1.99996 2.66666C1.99996 2.66666 -0.666707 8.66666 5.33329 11.3333C3.96031 12.2653 2.32473 12.7326 0.666626 12.6667C6.66663 16 14 12.6667 14 4.99999C13.9993 4.81429 13.9815 4.62905 13.9466 4.44666C14.627 3.77565 15.1072 2.92847 15.3333 1.99999V1.99999Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const RoundedDollarIcon = createIcon({
  displayName: "RoundedDollarIcon",
  viewBox: "0 0 112 112",
  path: (
    <g fill={"none"}>
      <circle cx="56" cy="56" r="56" fill="#F0F2F5" />
      <path
        d="M56 86C72.5685 86 86 72.5685 86 56C86 39.4315 72.5685 26 56 26C39.4315 26 26 39.4315 26 56C26 72.5685 39.4315 86 56 86Z"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M56 36V76"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M66.0001 44C61.4551 41.639 46.8521 39.855 46.8521 47.983C46.8521 57.714 65.0341 54.279 65.0341 62.865C65.0341 71.451 53.2161 70.807 45.0341 68.016"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const AccountIcon = createIcon({
  displayName: "AccountIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3V3ZM19 19H5V5H19V19Z"
      fill="currentColor"
    />
  ),
});

export const AccountsIcon = createIcon({
  displayName: "AccountsIcon",
  viewBox: "0 0 112 112",
  path: (
    <g fill={"none"}>
      <path
        d="M83 29H29V83H83V29Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M50 43L72 43"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M50 56L72 56"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M50 69L72 69"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M40 43H44"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M40 56H44"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M40 69H44"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const ExternalLinkIcon = createIcon({
  displayName: "ExternalLinkIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill={"none"}>
      <path
        d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 2H14V6"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 9.33333L14 2"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const BuildingsIcon = createIcon({
  displayName: "BuildingsIcon",
  viewBox: "0 0 64 64",
  path: (
    <g fill="none">
      <path
        d="M14.6667 60H4V33.3333H8"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22.6667 41.3333H28"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22.6667 49.3333H28"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22.6667 33.3333H28"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M30.6667 16V4L60 12V60H14.6667V22.6667H36V60"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M44 49.3333V20"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M52 49.3334V22.6667"
        stroke="#212121"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const TagsIcon = createIcon({
  displayName: "TagsIcon",
  viewBox: "0 0 112 112",
  path: (
    <g fill={"none"}>
      <path
        d="M60.485 83.828L78.828 65.485C79.1995 65.1136 79.4941 64.6726 79.6951 64.1873C79.8962 63.702 79.9996 63.1818 79.9996 62.6565C79.9996 62.1312 79.8962 61.611 79.6951 61.1257C79.4941 60.6404 79.1995 60.1994 78.828 59.828L52 33H28V57L54.828 83.828C55.1994 84.1995 55.6404 84.4941 56.1257 84.6951C56.611 84.8962 57.1312 84.9996 57.6565 84.9996C58.1818 84.9996 58.702 84.8962 59.1873 84.6951C59.6726 84.4941 60.1136 84.1995 60.485 83.828Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M82 54L55 27H31"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M42 52C44.7614 52 47 49.7614 47 47C47 44.2386 44.7614 42 42 42C39.2386 42 37 44.2386 37 47C37 49.7614 39.2386 52 42 52Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const ReportsIcon = createIcon({
  displayName: "ReportsIcon",
  viewBox: "0 0 64 64",
  path: (
    <g fill={"none"}>
      <path
        d="M17 43H5V59H17V43Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M37 24H25V59H37V24Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M59 5H47V59H59V5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const SettingsIcon = createIcon({
  displayName: "SettingsIcon",
  viewBox: "0 0 112 112",
  path: (
    <g fill={"none"}>
      <circle cx="56" cy="56" r="56" fill="#F0F2F5" />
      <path
        d="M56 65C60.9706 65 65 60.9706 65 56C65 51.0294 60.9706 47 56 47C51.0294 47 47 51.0294 47 56C47 60.9706 51.0294 65 56 65Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M86 56C86.0001 54.8848 85.5809 53.8103 84.8257 52.9897C84.0705 52.1691 83.0344 51.6623 81.923 51.57L77.273 51.181C76.7263 48.7677 75.7705 46.4658 74.447 44.375L77.47 40.8C78.1906 39.9489 78.5649 38.8581 78.5188 37.7439C78.4727 36.6297 78.0094 35.5736 77.221 34.785V34.785C76.4323 33.9968 75.3762 33.5337 74.2621 33.4876C73.1479 33.4414 72.0572 33.8157 71.206 34.536L67.633 37.559C65.5407 36.2312 63.2358 35.2726 60.819 34.725L60.43 30.075C60.3372 28.964 59.8303 27.9284 59.0097 27.1736C58.1891 26.4188 57.1149 25.9999 56 26V26C54.8848 25.9999 53.8103 26.4191 52.9897 27.1743C52.1691 27.9295 51.6623 28.9656 51.57 30.077L51.181 34.727C48.7677 35.2737 46.4658 36.2295 44.375 37.553L40.8 34.536C39.9487 33.8158 38.8579 33.4417 37.7437 33.4881C36.6296 33.5344 35.5736 33.9976 34.785 34.786V34.786C33.9968 35.5747 33.5337 36.6308 33.4876 37.7449C33.4414 38.8591 33.8157 39.9498 34.536 40.801L37.559 44.374C36.2321 46.4643 35.2735 48.7667 34.725 51.181L30.07 51.57C28.9599 51.664 27.9255 52.1714 27.1717 52.9919C26.418 53.8123 25.9998 54.8859 26 56V56C25.9999 57.1152 26.4191 58.1897 27.1743 59.0103C27.9295 59.8309 28.9656 60.3377 30.077 60.43L34.734 60.819C35.2803 63.2325 36.2361 65.5344 37.56 67.625L34.536 71.2C33.8158 72.0513 33.4417 73.1421 33.4881 74.2563C33.5344 75.3704 33.9976 76.4264 34.786 77.215V77.215C35.5747 78.0032 36.6308 78.4663 37.7449 78.5124C38.8591 78.5586 39.9498 78.1843 40.801 77.464L44.374 74.441C46.4643 75.7679 48.7667 76.7265 51.181 77.275L51.57 81.932C51.6645 83.0418 52.1721 84.0757 52.9925 84.829C53.8129 85.5824 54.8862 86.0003 56 86V86C57.1152 86.0001 58.1897 85.5809 59.0103 84.8257C59.8309 84.0705 60.3377 83.0344 60.43 81.923L60.819 77.266C63.2325 76.7197 65.5344 75.7639 67.625 74.44L71.2 77.464C72.0513 78.1842 73.1421 78.5583 74.2563 78.5119C75.3704 78.4656 76.4264 78.0024 77.215 77.214C78.0032 76.4253 78.4663 75.3692 78.5124 74.2551C78.5586 73.1409 78.1843 72.0502 77.464 71.199L74.441 67.626C75.7679 65.5357 76.7265 63.2333 77.275 60.819L81.932 60.43C83.0418 60.3355 84.0757 59.8279 84.829 59.0075C85.5824 58.1871 86.0003 57.1138 86 56V56Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const CopyIcon = createIcon({
  displayName: "CopyIcon",
  viewBox: "0 0 24 24",
  path: (
    <g fill={"none"}>
      <path
        d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const BankAccountActivityIcon = createIcon({
  displayName: "BankAccountActivityIcon",
  viewBox: "0 0 32 32",
  path: (
    <g fill="none">
      <path
        d="M9 10H15"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9 16H15"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9 22H13"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 1V9H29"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M30 30L26.535 26.535"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M23 28C25.7614 28 28 25.7614 28 23C28 20.2386 25.7614 18 23 18C20.2386 18 18 20.2386 18 23C18 25.7614 20.2386 28 23 28Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M29 15V9L21 1H3V31H17"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  ),
});

export const VerifySponsorFeesIcon = createIcon({
  displayName: "VerifySponsorFeesIcon",
  viewBox: "0 0 32 32",
  path: (
    <g fill="none">
      <path
        d="M1.33337 12.0001H16"
        stroke="black"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33337 8.66675H12.0667"
        stroke="black"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3334 16.6V21.3333H1.33337V9.33333V4H21.3334V8"
        stroke="black"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3334 16.6666H9.3334"
        stroke="black"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0001 17.3333C21.0667 17.3333 18.6667 14.9333 18.6667 12H16.0001C13.8001 12 12.0001 10.2 12.0001 8H21.2667C26.3334 8 30.6001 12 30.6667 17.0667C30.7334 22.3333 26.6667 26.6667 21.3334 26.6667C17.7334 26.6667 12.3334 26.0667 9.1334 25.6667C7.60007 25.4667 6.3334 24.4 5.86674 22.9333L5.3334 21.3333"
        stroke="black"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const ConfirmRelatedTransactionsIcon = createIcon({
  displayName: "ConfirmRelatedTransactionsIcon",
  viewBox: "0 0 32 32",
  path: (
    <g fill="none">
      <path
        d="M6.66665 11.9999C9.61217 11.9999 12 9.6121 12 6.66659C12 3.72107 9.61217 1.33325 6.66665 1.33325C3.72113 1.33325 1.33331 3.72107 1.33331 6.66659C1.33331 9.6121 3.72113 11.9999 6.66665 11.9999Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3334 30.6667C28.2789 30.6667 30.6667 28.2789 30.6667 25.3333C30.6667 22.3878 28.2789 20 25.3334 20C22.3879 20 20.0001 22.3878 20.0001 25.3333C20.0001 28.2789 22.3879 30.6667 25.3334 30.6667Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3334 6.66663H22.6667C25.612 6.66663 28 9.05463 28 12V14.6666"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 25.3333H9.33339C6.38806 25.3333 4.00006 22.9453 4.00006 19.9999V17.3333"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3334 2.66663L17.3334 6.66663L21.3334 10.6666"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 21.3333L14.6667 25.3333L10.6667 29.3333"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const FinancialStatementsIcon = createIcon({
  displayName: "FinancialStatementsIcon",
  viewBox: "0 0 32 32",
  path: (
    <g fill="none">
      <path
        d="M25.3333 30.6667L4 28.6667V3.33337L25.3333 1.33337V30.6667Z"
        stroke="black"
        strokeWidth="1.56665"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3334 4V28"
        stroke="black"
        strokeWidth="1.56665"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66669 19.3334H19.3334"
        stroke="black"
        strokeWidth="1.56665"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66669 24L19.3334 24.6667"
        stroke="black"
        strokeWidth="1.56665"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14.6666C16.2091 14.6666 18 12.8758 18 10.6666C18 8.45749 16.2091 6.66663 14 6.66663C11.7909 6.66663 10 8.45749 10 10.6666C10 12.8758 11.7909 14.6666 14 14.6666Z"
        stroke="black"
        strokeWidth="1.56665"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const KeyDocumentsIcon = createIcon({
  displayName: "KeyDocumentsIcon",
  viewBox: "0 0 32 32",
  path: (
    <g fill="none">
      <path
        d="M28 29.3334H4.00004C3.2928 29.3334 2.61452 29.0525 2.11442 28.5524C1.61433 28.0523 1.33337 27.374 1.33337 26.6668V2.66675H12L15.3334 8.00008H30.6667V26.6668C30.6667 27.374 30.3858 28.0523 29.8857 28.5524C29.3856 29.0525 28.7073 29.3334 28 29.3334Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12.9601L17.854 16.7168L22 17.3194L19 20.2441L19.7087 24.3734L16 22.4234L12.2913 24.3734L13 20.2441L10 17.3194L14.146 16.7168L16 12.9601Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const OperatingAgreementIcon = createIcon({
  displayName: "OperatingAgreementIcon",
  viewBox: "0 0 32 32",
  path: (
    <g fill="none">
      <path
        d="M1.33337 30.6667H30.6667"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33337 26C3.33337 26 4.29871 19.7013 5.77137 18.2287L21.562 2.438C23.0347 0.965329 25.4227 0.965329 26.8954 2.438C28.368 3.91066 28.368 6.29866 26.8954 7.77133L11.1047 23.562C9.63271 25.0333 3.33337 26 3.33337 26Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00006 18C8.00006 18 9.00006 18.3333 10.0001 19.3333C11.0001 20.3333 11.3334 21.3333 11.3334 23.3333"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.0001 11.3333L29.3334 12.6666L24.0001 17.9999"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const MenuItemCaretIcon = createIcon({
  displayName: "MenuItemCaretIcon",
  viewBox: "0 0 7 12",
  path: (
    <g fill={"none"}>
      <path
        d="M6 6L6.70711 6.70711C7.09763 6.31658 7.09763 5.68342 6.70711 5.29289L6 6ZM0.292893 1.70711L5.29289 6.70711L6.70711 5.29289L1.70711 0.292893L0.292893 1.70711ZM5.29289 5.29289L0.292893 10.2929L1.70711 11.7071L6.70711 6.70711L5.29289 5.29289Z"
        fill="currentColor"
      />
    </g>
  ),
});

export const UpdateIcon = createIcon({
  displayName: "UpdateIcon",
  viewBox: "0 0 14 16",
  path: (
    <g fill="none">
      <path
        d="M8.5 3C9.7 3 10.7 3.4 11.7 4H9V6H15V0H13V2.5C11.7 1.5 10.2 1 8.5 1C4.6 1 1.3 4 1 7.9L3 8.1C3.2 5.2 5.6 3 8.5 3Z"
        fill="currentColor"
      />
      <path
        d="M7.5 13C6.3 13 5.3 12.6 4.3 12H7V9.99999H1V16H3V13.5C4.3 14.5 5.8 15 7.5 15C11.4 15 14.7 12 15 8.09999L13 7.89999C12.8 10.8 10.4 13 7.5 13Z"
        fill="currentColor"
      />
    </g>
  ),
});

/* Controls */

export const ControlsVideoPlay = createIcon({
  displayName: "ControlsVideoPlay",
  viewBox: "0 0 48 48",
  path: (
    <g fill="none">
      <path
        d="M40.9705 7.02938C36.4375 2.49638 30.4106 0 24 0C17.5893 0 11.5624 2.49647 7.02938 7.02938C2.49647 11.5624 0 17.5894 0 24C0 30.4107 2.49647 36.4376 7.02938 40.9706C11.5624 45.5035 17.5893 48 24 48C30.4106 48 36.4375 45.5035 40.9705 40.9706C45.5035 36.4375 48 30.4106 48 24C48 17.5894 45.5035 11.5625 40.9705 7.02938ZM37.5832 25.1702L19.5081 37.2201C19.2727 37.377 19.0008 37.4563 18.728 37.4563C18.5004 37.4563 18.2724 37.4012 18.0645 37.2899C17.6073 37.0453 17.3218 36.5687 17.3218 36.0501V11.95C17.3218 11.4314 17.6073 10.9549 18.0645 10.7102C18.5216 10.4655 19.0765 10.4922 19.5081 10.78L37.5832 22.83C37.9744 23.0908 38.2094 23.5299 38.2094 24.0001C38.2093 24.4703 37.9744 24.9093 37.5832 25.1702Z"
        fill="currentColor"
      />
    </g>
  ),
});
export const FBChecked = createIcon({
  displayName: "FBChecked",
  viewBox: "0 0 22 22",
  path: (
    <g
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11C22 13.9174 20.8408 16.7152 18.7778 18.7782C16.715 20.8412 13.9176 22 11 22C8.08246 22 5.28508 20.8412 3.22216 18.7782C1.15923 16.7152 0 13.9174 0 11C0 8.08263 1.15923 5.28474 3.22216 3.22182C5.28508 1.1589 8.08246 0 11 0C13.9176 0 16.715 1.1589 18.7778 3.22182C20.8408 5.28474 22 8.08263 22 11ZM16.5414 6.83371C16.4433 6.7359 16.3257 6.65881 16.197 6.6072C16.0684 6.5555 15.9306 6.53036 15.7926 6.53316C15.6538 6.53604 15.5168 6.56675 15.3907 6.62361C15.2638 6.68047 15.1504 6.7622 15.0564 6.864L10.2808 12.9484L7.40299 10.0691C7.20753 9.88698 6.94862 9.7878 6.68208 9.79257C6.4147 9.79715 6.16 9.90541 5.97046 10.0943C5.78176 10.2833 5.67346 10.5383 5.66923 10.8054C5.66415 11.0726 5.76316 11.3311 5.94508 11.5266L9.58357 15.1663C9.68165 15.2642 9.79843 15.3412 9.92704 15.3929C10.0557 15.4446 10.1928 15.47 10.3316 15.4675C10.4694 15.4649 10.6066 15.4345 10.7326 15.378C10.8596 15.3214 10.973 15.2401 11.0677 15.1388L16.5567 8.2775C16.7437 8.08297 16.847 7.82278 16.8444 7.55286C16.8418 7.28284 16.7336 7.02468 16.5424 6.83371H16.5414Z"
        fill="#4EBC3C"
      />
    </g>
  ),
});
export const FBUnChecked = createIcon({
  displayName: "FBUnChecked",
  viewBox: "0 0 24 24",
  path: (
    <g
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 6.13737 18.4136 1.34594 12.6331 1.01792C12.5907 1.00624 12.5461 1 12.5 1C12.4702 1 12.441 1.0026 12.4127 1.0076C12.2757 1.00255 12.1382 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        fill="#A0ABC0"
      />
    </g>
  ),
});
